window.anotherArticlesSliderInit = function () {
	var $ = window.jQuery;

	if (!$) {
		return;
	}

	var $section = $('.blog-another-articles');
	var $wrapper = $section.find('.blog-another-articles__slider-wrapper');
	var $slider = $wrapper.find('.js-slider-articles');

	if (!$slider.length || $slider.hasClass('slick-initialized')) {
		return;
	}

	$slider.slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		dots: false,
		prevArrow: $section.find('.js-slider-articles--prev'),
		nextArrow: $section.find('.js-slider-articles--next'),
		appendDots: $wrapper.find('.js-slider-articles-dots'),
		responsive: [{
			breakpoint: 1280,
			settings: {
				arrows: true,
				dots: false
			}
		}, {
			breakpoint: 1023,
			settings: {
				slidesToShow: 2,
				arrows: true,
				dots: false
			}
		}, {
			breakpoint: 579,
			settings: {
				slidesToShow: 1,
				arrows: false,
				dots: true
			}
		}]
	});
};
